import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import "./featuredPosts.css"

const FeaturedPostsCarousel = ({ posts }) => {
return (
    <section className="featured-posts">
        <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            autoplay={{ delay: 4500 }}
            pagination={{ clickable: true }}
            breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            }}
        >
        {posts.map((post) => (
            <SwiperSlide key={post.id}>
                <Link to={`/blog/${post.slug}`} className="featured-card">
                    {post.image && (
                        <img src={post.image} alt={post.title} />
                    )}
                    <div className="featured-card-content">
                        <h3>{post.title}</h3>
                        <p dangerouslySetInnerHTML={{ __html: post.excerpt }} />
                    </div>
                </Link>
            </SwiperSlide>
            ))}
        </Swiper>
        </section>
    );
};

export default FeaturedPostsCarousel;
